import { memo, MouseEventHandler } from 'react';
import styled from '@emotion/styled';
import chartSvg from '../assets/chart.svg';

interface DashboardNavProps {
  trans: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLElement>;
}
function DashboardNav(props: DashboardNavProps) {
  const { trans, onClick: handler, ...rest } = props;
  const Chart = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: 30px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: normal;
    color: #515359;
    background: #f0f4ff;
    cursor: pointer;
    > img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    &:hover {
      color: #336fff;
    }
  `;

  return (
    <Chart onClick={handler} {...rest}>
      <img src={chartSvg} alt="chart" />
      <span>{trans}</span>
    </Chart>
  );
}
export default memo(DashboardNav);
